import { type EmailOtpRepository, TwoFactorMethodTypeOptions } from '@contexts/auth/domain';
import type { EnvironmentRepository, HttpService } from '@contexts/shared/domain';

export function restApiEmailOtpRepositoryBuilder(
	environment: EnvironmentRepository,
	httpService: HttpService
): EmailOtpRepository {
	return {
		async generateSecret(token: string): Promise<void> {
			await httpService.post<void>(
				`${environment.apiBaseUrl}/auth/2fa/request-code`,
				{
					token,
					methodType: TwoFactorMethodTypeOptions.EMAIL
				},
				undefined
			);

			return void 0;
		},
		async verifyCode(token: string, code: string): Promise<void> {
			await httpService.post<{ token: string }>(
				`${environment.apiBaseUrl}/auth/totp/code`,
				{
					token,
					code
				},
				undefined
			);
		}
	};
}
